import { SetStateAction, createContext } from 'react';
import { ExternalApiEndpoint } from '~/queries';

type ParameterValue = string | number | boolean | undefined;
type Parameters = Record<string, ParameterValue>;

export interface ApiHelperContextType {
  server: string;
  endpoint: ExternalApiEndpoint;
  pathParameters: Record<string, string | undefined>;
  setPathParameters: (value: SetStateAction<Record<string, string | undefined>>) => void;
  setPathParameter: (key: string, value: string | undefined) => void;
  queryParameters: Parameters;
  setQueryParameters: (value: SetStateAction<Parameters>) => void;
  setQueryParameter: (key: keyof Parameters, value: Parameters[keyof Parameters]) => void;
  payload?: string;
  setPayload: (payload: SetStateAction<string | undefined>) => void;
  payloads: { list: { name: string; payload: string }[]; required: boolean };
}

export const ApiHelperContext = createContext<ApiHelperContextType>({
  server: '',
  endpoint: {} as ExternalApiEndpoint,
  pathParameters: {},
  setPathParameter: () => null,
  setPathParameters: () => null,
  queryParameters: {},
  setQueryParameter: () => null,
  setQueryParameters: () => null,
  payload: undefined,
  setPayload: () => null,
  payloads: { list: [], required: false },
});
